<template>
  <button
    class="btn"
    type="button"
    :disabled="disabled || processing"
    @click="handleClick"
  >
    <span
      v-if="screenReaderText"
      class="sr-only"
    >
      {{ screenReaderText }}
    </span>

    <div class="flex items-center gap-2">
      <FontAwesomeIcon
        v-if="processing"
        :icon="faSpinnerThird"
        spin
        class="text-lg"
      />

      <slot>
        <FontAwesomeIcon
          v-if="icon"
          :icon="icon"
          class="text-sm"
        />

        <span
          v-if="text"
          :class="{ '-ml-1': icon }"
        >
          {{ text }}
        </span>
      </slot>
    </div>
  </button>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';

const emit = defineEmits(['click']);

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  processing: {
    type: Boolean,
    default: false,
  },
  screenReaderText: {
    type: String,
    default: '',
  },
  icon: {
    type: Object,
    default: () => null,
  },
  text: {
    type: String,
    default: null,
  },
});

const handleClick = () => {
  if (!props.disabled) {
    emit('click');
  }
};
</script>
